import * as React from 'react';
import { type IconProps } from './Icon.types';

const InfoLightIcon: React.FC<IconProps> = ({
  className,
  width = 32,
  height = 32,
  fill = 'currentColor',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    className={className}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.9242 22.8715V14.9568C15.9242 14.6569 15.8051 14.3693 15.593 14.1573C15.3809 13.9453 15.0934 13.8262 14.7935 13.8262H13.6628"
      stroke={fill}
      strokeWidth="1.0016"
      strokeLinecap="round"
      strokeLinejoin="round"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M15.3588 10.4832C15.0465 10.4832 14.7935 10.2301 14.7935 9.91787C14.7935 9.60564 15.0465 9.35254 15.3588 9.35254"
      stroke={fill}
      strokeWidth="1.0016"
      strokeLinecap="round"
      strokeLinejoin="round"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M15.3586 10.4832C15.671 10.4832 15.924 10.2301 15.924 9.91787C15.924 9.60564 15.671 9.35254 15.3586 9.35254"
      stroke={fill}
      strokeWidth="1.0016"
      strokeLinecap="round"
      strokeLinejoin="round"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M16.0002 30.5023C24.0098 30.5023 30.5028 24.0093 30.5028 15.9997C30.5028 7.9901 24.0098 1.49707 16.0002 1.49707C7.99059 1.49707 1.49756 7.9901 1.49756 15.9997C1.49756 24.0093 7.99059 30.5023 16.0002 30.5023Z"
      stroke={fill}
      strokeWidth="1.0016"
      strokeLinecap="round"
      strokeLinejoin="round"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M13.6628 22.8721H18.3371"
      stroke={fill}
      strokeWidth="1.0016"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);

export default React.memo(InfoLightIcon);
